var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4DB5FF",
    stroke: "none",
    d: " M 64.15 20.85 Q 63.35 22.8 62.95 23.7 62.55 24.55 62.2 25.35 L 53.75 43.1 Q 52.05 46.6 51.5 47.85 L 50.05 51.15 Q 49.1 48 48.5 46.1 L 41.95 26.3 Q 41.45 24.75 41.15 23.85 L 40.35 20.85 Q 37.5 20.9 36.35 20.9 35.3 20.9 33.95 20.9 L 33.95 20.85 Q 33.35 20.85 32.85 20.9 32.35 20.85 31.75 20.85 L 31.8 20.9 Q 30.3 20.9 29.65 20.9 28.75 20.9 25.55 20.85 25.55 25.5 25.4 29.65 25.3 34.65 25.1 38.65 24.9 43.8 24.6 46.05 24.4 47.7 24 48.65 23.65 49.6 23.05 50.3 22.65 50.8 22.05 51.2 21.25 51.65 20.2 51.95 19 52.3 17.75 52.3 16.15 52.3 14.25 52.2 12.35 52.1 6.85 50.35 6.95 54.15 9.7 57.05 15.85 58.3 19.95 58.3 22.4 58.3 24.5 57.8 26.35 57.35 28 56.45 29.25 55.8 30.15 54.95 30.9 54.15 31.4 53.2 31.95 52.1 32.25 50.7 32.6 48.9 32.8 43.9 33 36.6 33.25 32.4 L 33.65 26.1 41.8 49.1 Q 43.35 53.6 43.55 54.25 L 44.6 57.65 Q 48.45 57.6 49.55 57.6 50.7 57.6 54.2 57.65 L 72.55 21.5 Q 72.35 21.15 72.15 20.85 69.45 20.9 68.6 20.9 67.1 20.9 64.15 20.85 M 72.65 20.6 Q 72.85 20.9 73.05 21.25 L 73.35 20.6 Q 73 20.6 72.65 20.6 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_MEMBER_0_1_STROKES",
    stroke: "#0099FF",
    strokeWidth: 4.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 72.65 20.6 Q 72.85 20.9 73.05 21.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_MEMBER_0_2_STROKES",
    stroke: "#4DB5FF",
    strokeWidth: 4.7,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 72.65 20.6 Q 70.45 17.1 67.3 14 56.4 3.1 41 3.1 25.6 3.1 14.75 14 3.85 24.85 3.85 40.3 3.85 55.7 14.75 66.55 25.6 77.45 41 77.45 56.4 77.45 67.3 66.55 78.2 55.7 78.2 40.3 78.2 29.7 73.05 21.25"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_2_STROKES"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.053a41eb069500e4d3c63af4f1667bf4.svg";
export { ForwardRef as ReactComponent };